import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { brand_email, brand_phone, allowed_cities, instagram_url, facebook_url } = useSettings();
  const zonesText = (allowed_cities || ["Delhi NCR"]).join(", ");
  return (
    <footer className="bg-[#1E1B18] text-[#FBF8F3] mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.jpeg" alt="Dadu&apos;s Achaar" className="w-11 h-11 rounded-full object-cover ring-2 ring-[#E5A83B]/60" />
              <div>
                <div className="font-serif text-2xl">Dadu&apos;s Achaar</div>
                <div className="text-xs uppercase tracking-[0.25em] text-[#E5A83B]">Ghar ka Swaad · Dadu ka Vaada</div>
              </div>
            </div>
            <p className="text-sm text-[#B8B0A6] max-w-md leading-relaxed">
              Ancestral recipes hand-crafted in small home batches. Organic cold-pressed mustard oil, no chemical preservatives, and the unmistakable soul of a grandfather&apos;s kitchen.
            </p>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Shop</h4>
            <ul className="space-y-2 text-sm text-[#B8B0A6]">
              <li><Link to="/shop" data-testid="footer-link-shop" className="hover:text-[#E5A83B]">All Pickles</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="hover:text-[#E5A83B]">Our Story</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-[#E5A83B]">Contact & Delivery</Link></li>
              <li><Link to="/admin/login" data-testid="footer-link-admin" className="hover:text-[#E5A83B]">Admin Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-[#B8B0A6]">
              <li><Link to="/refund-policy" data-testid="footer-link-refund" className="hover:text-[#E5A83B]">Refund Policy</Link></li>
              <li><Link to="/shipping-policy" data-testid="footer-link-shipping" className="hover:text-[#E5A83B]">Shipping Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-link-terms" className="hover:text-[#E5A83B]">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" data-testid="footer-link-privacy" className="hover:text-[#E5A83B]">Privacy Policy</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Reach Us</h4>
            <ul className="space-y-3 text-sm text-[#B8B0A6]">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#E5A83B]" /> {zonesText} delivery zone</li>
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#E5A83B]" /> {brand_phone ? `+91 ${brand_phone}` : "+91 · Coming soon"}</li>
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#E5A83B]" /> {brand_email || "hello@dadusachaar.com"}</li>
              <li className="flex gap-3 pt-1">
                {instagram_url ? (
                  <a href={instagram_url} target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="hover:text-[#E5A83B]" aria-label="Instagram"><Instagram className="w-5 h-5" /></a>
                ) : null}
                {facebook_url ? (
                  <a href={facebook_url} target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="hover:text-[#E5A83B]" aria-label="Facebook"><Facebook className="w-5 h-5" /></a>
                ) : null}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#38332D] flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#8A8177]">
          <div>© {new Date().getFullYear()} Dadu's Achaar. All rights reserved. · dadusachaar.com</div>
          <div>Made with love, mustard oil & sunlight ☀️</div>
        </div>
      </div>
    </footer>
  );
}
